import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      padding: `${pxToRem(48)} ${pxToRem(140)} ${pxToRem(140)} ${pxToRem(140)}`,
    },
    title: {
      textAlign: 'center',
    },
    marginTop: {
      marginTop: 20,
    },
  };
});

export default useStyles;
